import { render } from "./FooterWrapper.vue?vue&type=template&id=22c83f75&ts=true"
import script from "./FooterWrapper.vue?vue&type=script&lang=ts"
export * from "./FooterWrapper.vue?vue&type=script&lang=ts"

import "./FooterWrapper.vue?vue&type=style&index=0&id=22c83f75&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__